<template>
  <div class="input">
    <label
      class="input__label"
      :for="id"
      :class="{
        'input__label--hidden': hideLabel,
        'input__label--disabled': disabled,
      }"
    >
      {{ label }}
    </label>
    <input
      :id="id"
      ref="input"
      :class="[
        'input__control',
        `input__control--${variant}`,
        { 'input__control--error': hasError },
      ]"
      :data-value="internalValue"
      :value="internalValue"
      :type="type"
      :aria-invalid="hasError"
      :aria-disabled="disabled"
      :disabled="disabled"
      :readonly="readonly"
      :placeholder="placeholder"
      @input="handleOnInput"
      @change="handleOnChange"
    >
    <div
      v-if="hasError"
      class="input__error"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
    name: 'HYInput',
    props: {
        label: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        variant: {
            type: String,
            default: 'default',
        },
        type: {
            type: String,
            default: 'text',
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        hideLabel: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: '',
        },
        externalValue: {
            type: String,
            default: '',
        },
        errorMessage: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            internalValue: '',
        };
    },
    watch: {
        externalValue(newVal) {
            this.internalValue = newVal;
        },
    },
    mounted() {
        this.internalValue = this.externalValue;
    },
    methods: {
        handleOnInput(event) {
            this.internalValue = event.target.value;
            this.$emit('input', event.target.value);
        },
        handleOnChange(event) {
            this.$emit('change', event.target.value);
        },
    },
};
</script>

<style src="./HYInput.scss" lang="scss" scoped></style>
